import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Input } from '@mui/material';
export default function FileInputButton({ buttonProps, inputProps, children }) {
    return (_jsxs(Button, { component: "label", ...buttonProps, children: [children, _jsx(Input, { type: "file", sx: {
                    clip: 'rect(0 0 0 0)',
                    clipPath: 'inset(50%)',
                    height: 1,
                    overflow: 'hidden',
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    whiteSpace: 'nowrap',
                    width: 1,
                }, ...inputProps })] }));
}
